'use strict';

var React = require('react');
var reactElements = require('../../helpers/react-elements.js');
var component = require('../Join/component.js');
var Divider = require('./Divider.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const isFragment = reactElements.isElementOfType(React.Fragment);
const Breadcrumbs = React.forwardRef(({ children, ...props }, ref) => (React__default.default.createElement(styles.Styled.Ol, { ...props, ref: ref },
    React__default.default.createElement(component.Join, { joiner: React__default.default.createElement(Divider.Divider, null) }, React.Children.map(children, (child, index) => (React__default.default.createElement(styles.Styled.Li, { key: index }, reactElements.isElement(child) && !isFragment(child) ? child : React__default.default.createElement("span", null, child))))))));

exports.Breadcrumbs = Breadcrumbs;
//# sourceMappingURL=component.js.map
